(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3601,9635],{

/***/ 69635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43010);
/* harmony import */ var _components_global_FontLoader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53409);


var FontLoaderWrapper = function(param) {
    var _blok = param.blok, fontName = _blok.fontName, s3Path = _blok.s3Path;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_FontLoader__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        fontName: fontName,
        s3Path: s3Path,
        fullPath: true
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FontLoaderWrapper);


/***/ }),

/***/ 13601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_TypefaceCardsWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(43010);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.1.4_yscj52izot5zgtrz33zielpism/node_modules/next/link.js
var next_link = __webpack_require__(40559);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.0.0/node_modules/react/index.js
var react = __webpack_require__(85170);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-fast-marquee@1.3.5_zpnidt7m3osuk7shl3s4oenomq/node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(67399);
// EXTERNAL MODULE: ./components/global/Button/index.tsx + 2 modules
var Button = __webpack_require__(80772);
// EXTERNAL MODULE: ./lib/paths.ts + 1 modules
var lib_paths = __webpack_require__(47475);
// EXTERNAL MODULE: ./storyblok/components/FontLoaderWrapper.tsx
var FontLoaderWrapper = __webpack_require__(69635);
// EXTERNAL MODULE: ./components/global/TypefaceMarquee/TypefaceMarquee.module.scss
var TypefaceMarquee_module = __webpack_require__(73170);
var TypefaceMarquee_module_default = /*#__PURE__*/__webpack_require__.n(TypefaceMarquee_module);
;// CONCATENATED MODULE: ./components/global/TypefaceMarquee/TypefaceMarquee.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var Card = function(param) {
    var card = param.card, tabIndex = param.tabIndex;
    var ref;
    var paths = (0,lib_paths/* usePaths */._)();
    var colorPrimary = card.colorPrimary, colorBackground = card.colorBackground;
    var fontName = (ref = card.font[0]) === null || ref === void 0 ? void 0 : ref.fontName;
    var _obj;
    var _styles = (_obj = {}, _defineProperty(_obj, "--color-primary", colorPrimary || "black"), _defineProperty(_obj, "--color-background", colorBackground || "white"), _defineProperty(_obj, "--font", fontName), _obj);
    var slug = "".concat(card.fontName).toLowerCase().split(" ").join("-");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: paths.typefaces._slug(slug).$url(),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (TypefaceMarquee_module_default()).tag,
            tabIndex: tabIndex,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: _styles,
                className: (TypefaceMarquee_module_default()).card,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (TypefaceMarquee_module_default()).fontName,
                    children: card.fontName
                })
            })
        })
    });
};
var TypefaceMarquee = function(param) {
    var cards = param.cards, _direction = param.direction, direction = _direction === void 0 ? "left" : _direction, _speed = param.speed, speed = _speed === void 0 ? 20 : _speed;
    var ref = (0,react.useState)(true), running = ref[0], setRunning = ref[1];
    // We double the cards when there are fewer of them to ensure there are no gaps in the marquee
    var cardsMap = cards.length < 8 ? _toConsumableArray(cards).concat(_toConsumableArray(cards)) : cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: running ? (TypefaceMarquee_module_default()).marqueeRunning : (TypefaceMarquee_module_default()).marqueePaused,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TypefaceMarquee_module_default()).controlButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "button",
                    callBack: function() {
                        setRunning(!running);
                    },
                    children: running ? "Pause" : "Play"
                })
            }),
            cardsMap.map(function(card, index) {
                var _font = _slicedToArray(card.font, 1), cardFont = _font[0];
                if (!cardFont) return;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FontLoaderWrapper["default"], {
                    blok: cardFont
                }, "".concat(cardFont._uid, "-").concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                pauseOnHover: true,
                gradient: false,
                direction: direction,
                speed: speed,
                play: running,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (TypefaceMarquee_module_default()).marquee__list,
                    children: cardsMap.map(function(card, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (TypefaceMarquee_module_default()).marquee__listItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                                card: card,
                                tabIndex: running ? "-1" : "0"
                            })
                        }, "".concat(card._uid, "-").concat(index));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TypefaceMarquee_TypefaceMarquee = (TypefaceMarquee);

;// CONCATENATED MODULE: ./components/global/TypefaceMarquee/index.tsx


;// CONCATENATED MODULE: ./storyblok/components/TypefaceCardsWrapper.tsx


var TypefaceCardsWrapper = function(param) {
    var blok = param.blok;
    var cards = blok.cards, direction = blok.direction, speed = blok.speed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypefaceMarquee_TypefaceMarquee, {
        cards: cards,
        direction: direction,
        speed: speed
    });
};
/* harmony default export */ var components_TypefaceCardsWrapper = (TypefaceCardsWrapper);


/***/ }),

/***/ 73170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"TypefaceMarquee_card__TuYGQ","tag":"TypefaceMarquee_tag__jLMwf","fontName":"TypefaceMarquee_fontName___PV4i","marquee__list":"TypefaceMarquee_marquee__list__Ejh9y","marquee__listItem":"TypefaceMarquee_marquee__listItem__Q45bf","marqueePaused":"TypefaceMarquee_marqueePaused__hkBu9","controlButton":"TypefaceMarquee_controlButton__lUTDF"};

/***/ })

}]);